import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

const navItems = [
  { to: '/app', label: 'Beranda', icon: '⌂', end: true },
  { to: '/app/map', label: 'Peta', icon: '⌖' },
  { to: '/app/activity', label: 'Aktivitas', icon: '↗' },
  { to: '/app/story', label: 'Story', icon: '▣' },
  { to: '/app/learn', label: 'Edukasi', icon: '◫' },
  { to: '/app/actions', label: 'Aksi', icon: '✦' },
  { to: '/app/favorites', label: 'Favorit', icon: '♡' },
  { to: '/app/account', label: 'Akun', icon: '☺' },
];

const mobileNavItems = navItems.filter((item) => [
  '/app',
  '/app/map',
  '/app/activity',
  '/app/learn',
  '/app/actions',
].includes(item.to));

export function AppShell() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <NavLink to="/" className="app-sidebar__brand" aria-label="Kembali ke landing page">
          <BrandLogo />
        </NavLink>

        <div className="app-sidebar__section">
          <small className="app-sidebar__caption">Menu aplikasi</small>
          <nav className="app-nav" aria-label="Navigasi aplikasi">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `app-nav__item ${isActive ? 'is-active' : ''}`}
              >
                <span aria-hidden="true">{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

      </aside>

      <header className="mobile-app-header">
        <NavLink to="/" aria-label="Kembali ke landing page"><BrandLogo compact /></NavLink>
        <div className="mobile-app-header__title">
          <strong>JakComfort</strong>
          <small>Comfort in Every Move</small>
        </div>
        <div className="mobile-app-header__actions">
          <span>☀ 29°C</span>
          <button type="button" onClick={() => setMobileMenuOpen(true)} aria-label="Buka semua menu">☰</button>
        </div>
      </header>

      <main className="app-main">
        <div className="app-topbar">
          <div>
            <small className="app-topbar__eyebrow">Prototype • Urban comfort & climate education</small>
            <strong className="app-topbar__title">JakComfort App Experience</strong>
          </div>
          <label className="app-topbar__search" aria-label="Cari menu atau lokasi">
            <span aria-hidden="true">⌕</span>
            <input type="text" placeholder="Cari menu, lokasi, aktivitas, atau topik edukasi..." />
          </label>
          <div className="app-topbar__actions">
            <div className="app-topbar__chip">☀ 29°C Jakarta</div>
          </div>
        </div>

        <div className="app-main__inner">
          <Outlet />
        </div>
      </main>

      <nav className="mobile-nav" aria-label="Navigasi bawah">
        {mobileNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `mobile-nav__item ${isActive ? 'is-active' : ''}`}
          >
            <span aria-hidden="true">{item.icon}</span>
            <small>{item.label}</small>
          </NavLink>
        ))}
      </nav>

      {mobileMenuOpen && (
        <div className="mobile-menu-backdrop" role="presentation" onMouseDown={() => setMobileMenuOpen(false)}>
          <aside className="mobile-menu-sheet" role="dialog" aria-modal="true" aria-label="Semua menu JakComfort" onMouseDown={(event) => event.stopPropagation()}>
            <div className="mobile-menu-sheet__header">
              <div><span className="eyebrow">Navigasi</span><h2>Semua menu</h2></div>
              <button type="button" onClick={() => setMobileMenuOpen(false)} aria-label="Tutup menu">×</button>
            </div>
            <nav className="mobile-menu-grid">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) => `mobile-menu-card ${isActive ? 'is-active' : ''}`}
                >
                  <span>{item.icon}</span>
                  <strong>{item.label}</strong>
                </NavLink>
              ))}
            </nav>
            <div className="mobile-menu-sheet__note">
              <strong>Tips penggunaan</strong>
              <p>Mulai dari Beranda, cek Peta, lalu hubungkan aktivitasmu untuk melihat rute nyata pada peta 2D.</p>
            </div>
          </aside>
        </div>
      )}
    </div>
  );
}
